import React from 'react';
import PropTypes from 'prop-types';

const svgComponents = import.meta.glob('../../../assets/svg/*.svg', {
  eager: true,
  query: '?react',
  import: 'default',
});

function SVG({ glyph, className, style }) {
  const SvgComponent = glyph ? svgComponents[`../../../assets/svg/${glyph}.svg`] : null;

  if (!SvgComponent) {
    return process.env.NODE_ENV === 'development' ? (
      <span className={className} style={style}>
        Error : No glyph &quot;{glyph}&quot;
      </span>
    ) : null;
  }

  return <SvgComponent className={className} style={style} />;
}

SVG.propTypes = {
  glyph: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SVG;
